<template>
  <Button
    v-if="hasSuggestionsToApply"
    v-tooltip="{
      value: t('titletags.applyAllSuggestions'),
      showDelay: 1000,
    }"
    icon="pi pi-check-circle"
    :label="buttonLabel || t('buttons.applyAllSuggestions')"
    outlined
    :class="`apply-all-suggestions-btn apply-suggestions-${suggestionsSource}`"
    @click="onApplyAllSuggestions"
  />
</template>

<script setup lang="ts">
import Button from 'primevue/button';
import { useI18n } from 'vue-i18n';

import type { InvoiceItemSuggestionSource } from '@/views/operatingcostinvoices/components/operationcostinvoicelines/operatingCostInvoiceTypes';

const { t } = useI18n();

withDefaults(
  defineProps<{
    onApplyAllSuggestions: () => void;
    suggestionsSource?: InvoiceItemSuggestionSource;
    hasSuggestionsToApply?: boolean;
    buttonLabel?: string;
  }>(),
  {
    suggestionsSource: undefined,
    hasSuggestionsToApply: false,
    buttonLabel: undefined,
  },
);
</script>

<style scoped>
/* Apply suggestions button - color variants based on source */
/* Uses CSS variables from src/assets/colors.css */
/* Colors automatically adapt to Light/Dark mode */

.apply-all-suggestions-btn {
  transition: all 0.2s ease;
}

/* AI suggestions: Purple palette */
.apply-suggestions-ai {
  color: var(--apply-suggestions-ai-color) !important;
  border-color: var(--apply-suggestions-ai-color) !important;
}

.apply-suggestions-ai:hover {
  background-color: var(--apply-suggestions-ai-color) !important;
  color: white !important;
  border-color: var(--apply-suggestions-ai-color) !important;
}

/* Latest/Previous data: Blue palette */
.apply-suggestions-latest {
  color: var(--apply-suggestions-latest-color) !important;
  border-color: var(--apply-suggestions-latest-color) !important;
}

.apply-suggestions-latest:hover {
  background-color: var(--apply-suggestions-latest-color) !important;
  color: white !important;
  border-color: var(--apply-suggestions-latest-color) !important;
}

/* Other suggestions: Gray palette */
.apply-suggestions-other {
  color: var(--apply-suggestions-other-color) !important;
  border-color: var(--apply-suggestions-other-color) !important;
}

.apply-suggestions-other:hover {
  background-color: var(--apply-suggestions-other-color) !important;
  color: white !important;
  border-color: var(--apply-suggestions-other-color) !important;
}
</style>
